module.exports = __webpack_public_path__ + "img/ic_license_sys.3ae2fb46.jpg";